import React from "react";

export const CurrencyIcon: React.FC<{ currency_name: string; className?: string }> = ({ currency_name, className }) => {
    const icons = ["usdt", "amd", "rub", "usd", "gel", "eur"];

    if (icons.includes(currency_name.toLowerCase())) return <img className={className} src={`/currency-icons/${currency_name.toLowerCase()}.png`} alt="" />;
    return <p className={className}>{currency_name}</p>;
};
